<template>
  <div
    class="modal fade"
    id="searchResultModal"
    data-focus="false"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    >
      <ValidationObserver
        ref="searchResultRef"
        class="modal-content"
        v-slot="{ handleSubmit }"
      >
        <div class="modal-header">
          <h5 class="modal-title">查詢結果全選 <strong style="font-size: 15px">共{{ totalPerson }}人</strong></h5>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for=""><span class="mark">*</span>功能</label>
            <ValidationProvider
              tag="section"
              name="功能"
              rules="required"
              v-slot="{ errors }"
            >
              <el-select class="w-100" placeholder="請選擇" v-model="modalValue.action">
                <el-option label="標記為過期" :value="0" />
                <el-option label="移除過期標記" :value="1" />
                <el-option label="履歷移除" :value="2" />
                <el-option label="維護廠別" :value="3" />
              </el-select>
              <span v-if="errors[0]" class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!-- 廠別 -->
          <div v-if="modalValue.action === 3" class="form-group">
            <label for=""><span class="mark">*</span>廠別</label>
            <ValidationProvider
              name="廠別"
              rules="required"
              v-slot="{ errors }"
            >
              <el-select v-model="modalValue.chooseFactory" multiple placeholder="請選擇">
                <el-option
                  v-for="factory in factoryOptions"
                  :key="factory.Guid"
                  :label="factory.Name"
                  :value="factory.Guid"
                >
                </el-option>
              </el-select>
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            關閉
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="handleSubmit(saveData)"
          >
            儲存
          </button>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["totalPerson"],

  name: "SearchResultAll",
  data() {
    return {
      factoryOptions: [],
      modalValue: {
        action: null,
        chooseFactory: [],
      },
    };
  },

  computed: {
    ...mapGetters(["searchResult"]),
  },

  watch: {
    searchResult: function (e) {
      if (e) {
        this.$refs.searchResultRef.reset();
        this.modalValue = {};
        this.$emit("closeActionBar");
        $("#searchResultModal").modal("show");
      } else {
        $("#searchResultModal").modal("hide");
      }
    },

    "modalValue.action": function (e) {
      if (e !== 3) {
        this.modalValue.chooseFactory = [];
      }
    },
  },

  methods: {
    saveData() {
      const params = JSON.parse(localStorage.getItem("PARAMS"));
      const demandNo = JSON.parse(localStorage.getItem("ResumeCard")).DemandNo;

      switch (this.modalValue.action) {
        case 0: // 標記過期
          this.updateLoading(true);
          this.$api.jobManagement
            .expireAllResume({
              ...params,
              ManpowerDemandNo: demandNo,
            })
            .then((response) => {
              if (response.status === 200) {
                this.closeModal();
                this.$notify({
                  title: "全部成功",
                  message: "已標記為過期",
                  type: "success",
                  duration: 2000,
                });
                this.$emit("getResume");
              }
              this.updateLoading(false);
            });
          break;
        case 1: // 移除過期標記
          this.updateLoading(true);
          this.$api.jobManagement
            .recoverAllResume({
              ...params,
              ManpowerDemandNo: demandNo,
            })
            .then((response) => {
              if (response.status === 200) {
                this.closeModal();
                this.$notify({
                  title: "全部成功",
                  message: "已移除過期標記",
                  type: "success",
                  duration: 2000,
                });
                this.$emit("getResume");
              }
              this.updateLoading(false);
            });
          break;
        case 2: // 移除履歷
          this.updateLoading(true);
          this.$api.jobManagement
            .removeAllResume({
              ...params,
              ManpowerDemandNo: demandNo,
            })
            .then((response) => {
              if (response.status === 200) {
                this.closeModal();
                this.$notify({
                  title: "全部成功",
                  message: "已移除履歷",
                  type: "success",
                  duration: 2000,
                });
                this.$emit("getResume");
              }
              this.updateLoading(false);
            });
          break;
        case 3: // 維護廠別
          this.updateLoading(true);
          this.$api.jobManagement
            .changeAllFactoryTypes({
              ...params,
              ManpowerDemandNo: demandNo,
              FactoryTypeGuids: this.modalValue.chooseFactory,
            })
            .then((response) => {
              if (response.status === 200) {
                this.closeModal();
                this.$notify({
                  title: "全部成功",
                  message: "已更新廠別",
                  type: "success",
                  duration: 2000,
                });
                this.$emit("getResume");
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 關閉 Modal
    closeModal() {
      this.$emit("clearSelectCard");
      this.$store.commit("OpenSearchResultModal", false);
    },

    // 取得 廠別
    getFactory() {
      this.$api.factory.getFactory().then((response) => {
        if (response.status === 200) {
          this.factoryOptions = response.data;
        }
      });
    },

    // loading
    ...mapActions(["updateLoading"])
  },

  created() {
    this.getFactory();
  },

  destroyed() {
    this.$emit("clearSelectCard");
    this.$store.commit("OpenSearchResultModal", false);
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
